export default __webpack_public_path__ + "static/media/user_placeholder.1bc903a9.png";